import { Navigate } from "react-router-dom";
import { APP_ROUTES } from "../../../../constants/appRoutes";
import { getDepartmentConfig } from "../../../Departments/utils/departmentConfig";
import { useUserPermissions } from "../../../SignIn/UserPermissionsContext";

const withMonthlyPaymentsAccess = (Component) => {
  const ProtectedMonthlyPaymentsTab = (props) => {
    const { userPermissions } = useUserPermissions();
    const { Finance } = getDepartmentConfig(
      Array.isArray(userPermissions) ? userPermissions : [],
    );
    const canAccess = Finance.show && Finance.cards.some(
      (card) => card.route === APP_ROUTES.MONTHLY_PAYMENTS,
    );

    if (!canAccess) {
      return <Navigate to={APP_ROUTES.DEPARTMENT_ALL_STAFF} replace />;
    }

    return <Component {...props} />;
  };
  ProtectedMonthlyPaymentsTab.displayName = `Protected${Component.name}`;
  return ProtectedMonthlyPaymentsTab;
};

export default withMonthlyPaymentsAccess;
